import styled from 'styled-components';

import { SquaredButton } from 'elements';

export const EnvSelectorStyled = styled.div.attrs({
  className: 'EnvSelectorStyled',
})`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0 1.5rem;
`;

export const OptionButtonGroup = styled.div.attrs({
  className: 'OptionButtonGroup',
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0.25rem 0 0.5rem;
`;

export const SelectOptionButton = styled(SquaredButton).attrs({
  className: 'SelectOptionButton',
})`
  height: 2.5rem;
  width: auto;
  padding: 0.25rem;
  margin-right: 0.5rem;

  span {
    font-size: 0.875rem;
  }
`;
